import React, { useState, useEffect } from "react";
import _ from "lodash";
import Grid from "@mui/material/Grid";
import { Box } from "@mui/system";
import IconButton from "@mui/material/IconButton";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import PauseIcon from "@mui/icons-material/Pause";
import { Translate } from "@mui/icons-material";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@mui/material";
import { unicodeToString } from "../../../Js/Common";
import ImageIcon from "@mui/icons-material/Image";
import AudioButton from "../../Media/AudioButton";
import VideocamIcon from "@mui/icons-material/Videocam";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import LinearProgress from "@mui/material/LinearProgress";
import Slide from "@mui/material/Slide";

var mediaFlags = {
  image: false,
  audio: false,
  video: false,
  article: false,
};

const MediaCard = (props) => {
  const classes = useStyles();

  const [isPlaying, setIsPlaying] = useState(false);
  const [isPlaying1, setIsPlaying1] = useState(false);
  const [mediaButtons, setMediaButtons] = useState(mediaFlags);
  const [audioProgress, setAudioProgress] = useState(0);
  const [progressView, setProgressView] = useState(false);

  useEffect(() => {
    setDefaultMediaType();
  }, [props]);

  const setDefaultMediaType = () => {
    if (
      (props.image && props.audio) ||
      (props.video && props.audio) ||
      (((typeof props.article == "string" && props.article) ||
        (typeof props.article == "object" &&
          props.article.length > 0 &&
          props.article[0]["text"].trim() != "" &&
          mediaButtons["article"])) &&
        props.audio)
    ) {
      setProgressView(true);
    }

    if (props.image) {
      setMediaFlags("image");
      return false;
    }
    if (props.audio) {
      setMediaFlags("audio");
      return false;
    }
    if (props.video) {
      setMediaFlags("video");
      return false;
    }
    if (props.article) {
      setMediaFlags("article");
      return false;
    }
  };

  const setMediaFlags = (mediaType) => {
    const obj = { ...mediaFlags };
    obj[mediaType] = true;
    setMediaButtons(obj);
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box sx={{ position: "relative" }}>
          {props.image && mediaButtons["image"] && (
            <Grid
              container
              sx={{
                height: "40vh",
                width: "100%",
                borderRadius: 5,
                backgroundColor: "#3eda00ff",
                alignItems: "center",
                justifyContent: "center",
                "@media (min-width: 1636px)": {
                  height: "45vh",
                },
                overflow: "hidden",
              }}
            >
              <Slide
                direction="up"
                timeout={500}
                in={true}
                mountOnEnter
                unmountOnExit
              >
                <img
                  src={`${sessionStorage.getItem("media_url")}image/${
                    props.image
                  }`}
                  width="100%"
                  height="100%"
                  style={{ borderRadius: 10, objectFit: "contain" }}
                />
              </Slide>
            </Grid>
          )}
          {props.video && mediaButtons["video"] && (
            <Grid
              container
              sx={{
                height: "40vh",
                width: "100%",
                borderRadius: 5,
                backgroundColor: "#3eda00ff",
                alignItems: "center",
                justifyContent: "center",
                "@media (min-width: 1636px)": {
                  height: "45vh",
                },
                overflow: "hidden",
              }}
            >
              <Slide
                direction="up"
                timeout={500}
                in={true}
                mountOnEnter
                unmountOnExit
              >
                <video
                  src={`${sessionStorage.getItem("media_url")}video/${
                    props.video
                  }`}
                  width="100%"
                  height="100%"
                  style={{ borderRadius: 10, objectFit: "contain" }}
                  controls={true}
                />
              </Slide>
            </Grid>
          )}
          {props.audio && mediaButtons["audio"] && (
            <Grid
              container
              sx={{
                height: "40vh",
                width: "100%",
                borderRadius: 5,
                backgroundColor: "#3eda00ff",
                alignItems: "center",
                justifyContent: "center",
                "@media (min-width: 1636px)": {
                  height: "45vh",
                },
                overflow: "hidden",
              }}
            >
              <AudioButton
                expertAudio={props.audio}
                playStatus={(status) => setIsPlaying(status)}
              >
                <Slide
                  direction="up"
                  timeout={500}
                  in={true}
                  mountOnEnter
                  unmountOnExit
                >
                  <IconButton sx={{ color: "#FFFFFF" }}>
                    {isPlaying && (
                      <PauseIcon
                        sx={{
                          fontSize: "15rem",
                          "@media (min-width: 1636px)": {
                            fontSize: "25rem",
                          },
                        }}
                      />
                    )}
                    {!isPlaying && (
                      <PlayArrowOutlinedIcon
                        sx={{
                          fontSize: "15rem",
                          "@media (min-width: 1636px)": {
                            fontSize: "25rem",
                          },
                        }}
                      />
                    )}
                  </IconButton>
                </Slide>
              </AudioButton>
            </Grid>
          )}
          {((typeof props.article == "string" &&
            props.article &&
            mediaButtons["article"]) ||
            (typeof props.article == "object" &&
              props.article.length > 0 &&
              props.article[0]["text"].trim() != "" &&
              mediaButtons["article"])) && (
            <Grid
              container
               
              sx={{
                height: "40vh",
                width: "100%",
                borderRadius: 5,
                display: "grid",
                backgroundColor: "#3eda00ff",
                alignItems: "center",
                pb: 3,
                "@media (min-width: 1636px)": {
                  height: "45vh",
                },
                overflow: "auto",
              }}
            >
              <Grid item>
                {typeof props.article == "string" && (
                  <Typography
                    sx={{
                      padding: 1,
                      color: "#5f5600ff",
                      fontWeight: "500",
                      fontSize: "1rem",
                      "@media (min-width: 1636px)": {
                        fontSize: "1.6rem",
                      },
                    }}
                  >
                    {unicodeToString(props.article)}
                  </Typography>
                )}
                {typeof props.article == "object" &&
                  props.article.map((val, index) => {
                    return (
                      <Typography
                        key={`${index}_articles`}
                        sx={{
                          padding: 1,
                          color: "#5f5600ff",
                          fontWeight: "500",
                          fontSize: "1rem",
                          "@media (min-width: 1636px)": {
                            fontSize: "1.6rem",
                          },
                        }}
                        textAlign={"left"}
                      >
                        {unicodeToString(val.text)}
                      </Typography>
                    );
                  })}
              </Grid>
            </Grid>
          )}
          <Box
            sx={{
              position: "absolute",
              bottom: -35,
              left: "50%",
              transform: "translate(-50%, -50%)",
              borderRadius: 10,
              "@media (min-width: 1636px)": {
                bottom: -50,
              },
            }}
          >
            {props.audio && !mediaButtons["audio"] && (
              <AudioButton
                expertAudio={props.audio}
                playStatus={(status) => setIsPlaying1(status)}
                onupdate={(obj) => {
                  setAudioProgress(obj.progress);
                }}
              >
                <IconButton
                  sx={{
                    boxShadow: 2,
                    backgroundColor: "#FFF",
                    color: "primary.main",
                    mx: 1,
                    padding: 0,
                    
                  }}
                >
                  {isPlaying1 && (
                    <PauseIcon
                      sx={{
                        borderRadius: "50%",
                        padding: 1,
                        "@media (min-width: 1636px)": {
                          fontSize: "2rem",
                        },
                      }}
                    />
                  )}
                  {!isPlaying1 && (
                    <PlayArrowOutlinedIcon
                      PlayArrowOutlinedIcon
                      sx={{
                        borderRadius: "50%",
                        padding: 1,
                        "@media (min-width: 1636px)": {
                          fontSize: "2rem",
                        },
                      }}
                    />
                  )}
                </IconButton>
              </AudioButton>
            )}
            {props.image && !mediaButtons["image"] && (
              <IconButton
                sx={{
                  boxShadow: 2,
                  backgroundColor: "#FFFFFF",
                  color: "primary.main",
                  mx: 1,
                  padding: 0,
                 
                }}
                onClick={() => {
                  setMediaFlags("image");
                }}
              >
                <ImageIcon
                  sx={{
                    borderRadius: "50%",
                    padding: 1,
                    "@media (min-width: 1636px)": {
                      fontSize: "2rem",
                    },
                  }}
                />
              </IconButton>
            )}
            {props.video && !mediaButtons["video"] && (
              <IconButton
                sx={{
                  boxShadow: 2,
                  backgroundColor: "#FFF",
                  color: "primary.main",
                  mx: 1,
                  padding: 0,
                  
                }}
                onClick={() => {
                  setMediaFlags("video");
                }}
              >
                <VideocamIcon
                  sx={{
                    borderRadius: "50%",
                    padding: 1,
                    "@media (min-width: 1636px)": {
                      fontSize: "2rem",
                    },
                  }}
                />
              </IconButton>
            )}
            {((typeof props.article == "string" && props.article) ||
              (typeof props.article == "object" &&
                props.article.length > 0 &&
                props.article[0]["text"].trim() != "")) &&
              !mediaButtons["article"] && (
                <IconButton
                  sx={{
                    boxShadow: 2,
                    backgroundColor: "#FFF",
                    color: "primary.main",
                    mx: 1,
                    padding: 0,
                    
                  }}
                  onClick={() => {
                    setMediaFlags("article");
                  }}
                >
                  <ArticleOutlinedIcon
                    sx={{
                      borderRadius: "50%",
                      padding: 1,
                      "@media (min-width: 1636px)": {
                        fontSize: "2rem",
                      },
                    }}
                  />
                </IconButton>
              )}
          </Box>
        </Box>
        <Box>
          {props.questionText && (
            <Typography
              sx={{
                fontSize: "1rem",
                color: "primary.main",
                fontWeight: 500,
                mt: 2,
                "@media (min-width: 1636px)": {
                  fontSize: "1.4rem",
                  mt: 4,
                },
              }}
            >
              {unicodeToString(props.questionText)}
            </Typography>
          )}
          {progressView && (
            <LinearProgress
              variant="determinate"
              value={audioProgress}
              sx={{
                fontSize: "1rem",
                color: "primary.main",
                fontWeight: 500,
                mt: 3,
                mx: 2,
                "@media (min-width: 1636px)": {
                  fontSize: "1.4rem",
                  mt: 5,
                },
              }}
            />
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});

export default MediaCard;
